import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { ManagerTable } from 'components/Tables/UserTable/managerTable';

const ManagerDetail: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <ManagerTable />
    </Container>
  );
});

export default ManagerDetail;
